var quantityLabel = "Aantal";
var quantityFlyoutHeader = "Kies het aantal";
var quantityFlyoutCTA = "Dit aantal selecteren";
var closeButton = "Sluiten";
var pricePlaceholder = "...";
var priceLabel = "Prijs";
var unitPriceLabel = "Prijs per stuk";
var incompatibilityMessage = "Niet beschikbaar met andere opties: ";
var select = "Selecteren...";
var percentSavings = "{{{PERCENT}}}% korting";
var sale = "Sale";
var amountSavings = "{{{AMOUNT}}} korting per stuk";
var amountSavingsWithSale = "{{{AMOUNT}}} korting per stuk + sale";
var seeMoreQuantities = "Meer hoeveelheden weergeven";
var required = "Verplicht";
var sample = "Proefmonster";
var estimatedQuantity = "Geschat aantal";
var numberOfRecipients = "{{{COUNT}}} ontvangers";
var recommendedCallout = "Aanbevolen";
var newCallout = "Nieuw";
var incompatibleLabel = "Incompatibel";
var outOfStockCallout = "Niet op voorraad";
var dismissAlert = "Melding sluiten";
var unwindingMessage_1 = "Incompatibel met {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2 = "Incompatibel met {{{ATTRIBUTE1}}} {{{OPTION1}}} en {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3 = "Incompatibel met {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} en {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more = "Incompatibel met meer dan {{{ATTRIBUTE_COUNT}}} opties.";
var unwindingAlertMessage_1 = "Om compatibel te zijn met {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} is gedeselecteerd.";
var unwindingAlertMessage_2 = "Om compatibel te zijn met {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}} en {{{ATTRIBUTE2}}} {{{OPTION2}}} zijn gedeselecteerd.";
var unwindingAlertMessage_3 = "Om compatibel te zijn met {{{ATTRIBUTE}}} {{{OPTION}}}: {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} en {{{ATTRIBUTE3}}} {{{OPTION3}}} zijn gedeselecteerd.";
var unwindingAlertMessage_more = "Om compatibel te zijn met {{{ATTRIBUTE}}} {{{OPTION}}}: meer dan {{{ATTRIBUTE_COUNT}}} opties zijn gedeselecteerd.";
var fullRangedHelperText = "{{{MINIMUM}}} {{{UNIT}}} tot {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText = "Minimaal {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets = "Voer een waarde van {{{MINIMUM}}} tot {{{MAXIMUM}}} pagina's in, inclusief omslag ";
var rangePartialRangedHelperTextForBooklets = "Ten minste {{{MINIMUM}}} pagina's, inclusief omslag ";
var rangedGeneralInputError = "Invoer is ongeldig";
var rangedBetweenRangesError = "Dichtstbijzijnde getallen zijn {{{LOWER}}} {{{UNIT}}} en {{{HIGHER}}} {{{UNIT}}}";
var rangedDecimalPrecisionError = "Getal kan niet meer dan 8 decimalen hebben";
var rangedMinInputValueError = "Het minimumgetal is {{{MINIMUM}}} {{{UNIT}}}";
var rangedMaxInputValueError = "Het maximumgetal is {{{MAXIMUM}}} {{{UNIT}}}";
var rangedNotANumberError = "Invoer moet een getal zijn";
var requiredAttributeFieldError = "Voer een waarde in tussen {{{LOWER}}} en {{{HIGHER}}} {{{UNIT}}}";
var rangedBetweenRangesErrorForBooklets = "Dichtstbijzijnde getallen zijn {{{LOWER}}} pagina's en {{{HIGHER}}} pagina's ";
var rangedMinInputValueErrorForBooklets = "Het minimumgetal is {{{MINIMUM}}} pagina's ";
var rangedMaxInputValueErrorForBooklets = "Het maximumgetal is {{{MAXIMUM}}} pagina's ";
var requiredAttributeFieldErrorForBooklets = "Voer een waarde van {{{LOWER}}} tot {{{HIGHER}}} pagina's in, inclusief omslag ";
var requiredInformationToast = "Vul alle vereiste gegevens in.";
var nlNl = {
	quantityLabel: quantityLabel,
	quantityFlyoutHeader: quantityFlyoutHeader,
	quantityFlyoutCTA: quantityFlyoutCTA,
	closeButton: closeButton,
	pricePlaceholder: pricePlaceholder,
	priceLabel: priceLabel,
	unitPriceLabel: unitPriceLabel,
	incompatibilityMessage: incompatibilityMessage,
	select: select,
	percentSavings: percentSavings,
	sale: sale,
	amountSavings: amountSavings,
	amountSavingsWithSale: amountSavingsWithSale,
	seeMoreQuantities: seeMoreQuantities,
	required: required,
	sample: sample,
	estimatedQuantity: estimatedQuantity,
	numberOfRecipients: numberOfRecipients,
	recommendedCallout: recommendedCallout,
	newCallout: newCallout,
	incompatibleLabel: incompatibleLabel,
	outOfStockCallout: outOfStockCallout,
	dismissAlert: dismissAlert,
	unwindingMessage_1: unwindingMessage_1,
	unwindingMessage_2: unwindingMessage_2,
	unwindingMessage_3: unwindingMessage_3,
	unwindingMessage_more: unwindingMessage_more,
	unwindingAlertMessage_1: unwindingAlertMessage_1,
	unwindingAlertMessage_2: unwindingAlertMessage_2,
	unwindingAlertMessage_3: unwindingAlertMessage_3,
	unwindingAlertMessage_more: unwindingAlertMessage_more,
	fullRangedHelperText: fullRangedHelperText,
	rangePartialRangedHelperText: rangePartialRangedHelperText,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets,
	rangedGeneralInputError: rangedGeneralInputError,
	rangedBetweenRangesError: rangedBetweenRangesError,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError,
	rangedMinInputValueError: rangedMinInputValueError,
	rangedMaxInputValueError: rangedMaxInputValueError,
	rangedNotANumberError: rangedNotANumberError,
	requiredAttributeFieldError: requiredAttributeFieldError,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets,
	requiredInformationToast: requiredInformationToast
};

export { amountSavings, amountSavingsWithSale, closeButton, nlNl as default, dismissAlert, estimatedQuantity, fullRangedHelperText, fullRangedHelperTextForBooklets, incompatibilityMessage, incompatibleLabel, newCallout, numberOfRecipients, outOfStockCallout, percentSavings, priceLabel, pricePlaceholder, quantityFlyoutCTA, quantityFlyoutHeader, quantityLabel, rangePartialRangedHelperText, rangePartialRangedHelperTextForBooklets, rangedBetweenRangesError, rangedBetweenRangesErrorForBooklets, rangedDecimalPrecisionError, rangedGeneralInputError, rangedMaxInputValueError, rangedMaxInputValueErrorForBooklets, rangedMinInputValueError, rangedMinInputValueErrorForBooklets, rangedNotANumberError, recommendedCallout, required, requiredAttributeFieldError, requiredAttributeFieldErrorForBooklets, requiredInformationToast, sale, sample, seeMoreQuantities, select, unitPriceLabel, unwindingAlertMessage_1, unwindingAlertMessage_2, unwindingAlertMessage_3, unwindingAlertMessage_more, unwindingMessage_1, unwindingMessage_2, unwindingMessage_3, unwindingMessage_more };
//# sourceMappingURL=nl-nl.json.mjs.map
